import { UserDto, UserRoles } from '../api/tenant/models/UserDto'
import Cookies from 'js-cookie'

export class AuthHelper {
    // public static getUser(auth0User: any): User {
    //     if (!auth0User['https://app.contxt.network/app_metadata']) {
    //         throw new Error(
    //             'User does not have the required app_metadata field',
    //         )
    //     }

    //     if (
    //         !auth0User['https://app.contxt.network/app_metadata'].personNodeId
    //     ) {
    //         throw new Error(
    //             'User does not have the required personNodeId field',
    //         )
    //     }

    //     if (
    //         !auth0User['https://app.contxt.network/app_metadata']
    //             .tenantCompanyNodeId
    //     ) {
    //         throw new Error(
    //             'User does not have the required tenantCompanyNodeId field',
    //         )
    //     }

    //     if (!auth0User['https://app.contxt.network/app_metadata'].roles) {
    //         throw new Error('User does not have the required roles field')
    //     }

    //     return {
    //         auth0User: auth0User,
    //         appMetaData: {
    //             personNodeId:
    //                 auth0User['https://app.contxt.network/app_metadata']
    //                     .personNodeId,
    //             tenantCompanyNodeId:
    //                 auth0User['https://app.contxt.network/app_metadata']
    //                     .tenantCompanyNodeId,
    //             roles: auth0User['https://app.contxt.network/app_metadata']
    //                 .roles,
    //         },
    //     }
    // }

    public static setTenantOverrideId(tenantOverrideId: string): void {
        Cookies.set('tenantOverrideId', tenantOverrideId, { expires: 730 }) // Expires in ~2 years (730 days)
    }

    public static getTenantOverrideId(): string | undefined {
        const tenantOverrideId = Cookies.get('tenantOverrideId')
        if (!tenantOverrideId) {
            return undefined
        } else {
            return tenantOverrideId
        }
    }

    public static removeTenantOverrideId() {
        Cookies.remove('tenantOverrideId')
    }

    public static userHasRole(user: UserDto, role: UserRoles): boolean {
        return user.userRoles.includes(role)
    }

    public static userHasSomeRoles(user: UserDto, roles: UserRoles[]): boolean {
        return roles.some((role) => user.userRoles.includes(role))
    }
}
